enum Offices {
  home = '/offices',
}

export default Offices;
